module.exports = __webpack_public_path__ + "static/media/icon-file.67bfc0be.svg";